import { styled } from "@mui/material";

const NameValuePairContainer = styled("div")`
  display: grid;
  grid-template-areas: "attributeName attributeValue";
  grid-template-columns: 2fr 2fr;
  align-items: center;
  grid-gap: 10px;
`;

const AttributeName = styled("label")`
  color: #666666;
  grid-area: attributeName;
  font-size: 14px;
  font-weight: 400;
`;

const AttributeValue = styled("label")<{ $emphasize?: boolean }>`
  color: #333333;
  font-size: 14px;
  font-weight: ${({ $emphasize }) => ($emphasize ? 600 : 500)};
  grid-area: attributeValue;
`;

export { NameValuePairContainer, AttributeName, AttributeValue };
